import { PurchaseModalContent } from "../components/Pricing/PurchaseModalContent/PurchaseModalContent";
import { usePrefetchPriceConfig } from "../hooks/usePriceConfig";

const PricingPage = () => {
  usePrefetchPriceConfig();

  return <PurchaseModalContent />;
};

export default PricingPage;
